export const extractContentFromHtml = (htmlString = ''): string => {
  const [onlyBodyFromHtml] = htmlString.includes('<body>')
    ? htmlString.substring(htmlString.lastIndexOf('</style>')).split('</body>')
    : [htmlString];

  return onlyBodyFromHtml.replace(/<.*?>/g, ' ').replace(/ +/g, ' ');
};
